<template>
    <v-content>
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <v-dialog v-model="snackbar.formModal"
                  transition="dialog-bottom-transition"
                  fullscreen
                  hide-overlay>
            <v-card>
                <OfficeBudgetExpensesUserList @dialogueClose="dialogueClose"
                          @formResponse="formResponse"
                          :companyData="companyData"
                          v-if="snackbar.userListComponent"
                          :key="index"></OfficeBudgetExpensesUserList>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.snackbar"
                    :color="snackbar.color"
                    :timeout="snackbar.timeout"
                    top>
            {{ snackbar.text }}
            <v-btn dark
                   text
                   @click="snackbar.snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-expansion-panels class="my-2" hover>
            <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('filter') }} </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row style="justify-content:center">

                        <div class="box-border col-3">
                            <v-radio-group v-model="officeTypeEN" row>

                                <v-radio :label="$t('company')" value="Company"></v-radio>
                                <v-radio :label="$t('branch')" value="Branch"></v-radio>
                                <v-radio :label="$t('depo')" value="Depo"></v-radio>
                            </v-radio-group>
                        </div>
                        <div class="box-border col-3" v-if="officeTypeEN=='Company'">
                            <v-autocomplete class="pa-2"
                                            :items="listDDLData.companyList"
                                            item-text="value"
                                            item-value="id"
                                            :label="$t('company')"
                                            required dense outlined
                                            v-model.number="logData.companyID">
                            </v-autocomplete>
                        </div>


                        <div class="box-border col-3" v-if="officeTypeEN=='Branch'">
                            <v-autocomplete class="pa-2"
                                            :items="listDDLData.branchList"
                                            item-text="value"
                                            item-value="id" dense outlined
                                            :label="$t('branch')"
                                            v-model.number="logData.branchID"></v-autocomplete>
                        </div>

                        <div class="box-border col-3" v-if="officeTypeEN=='Depo'">
                            <v-autocomplete class="pa-2"
                                            :items="listDDLData.depoList"
                                            item-text="value"
                                            item-value="id"
                                            :label="$t('depo')" dense outlined
                                            v-model.number="logData.depoID">
                            </v-autocomplete>
                        </div>


                    </v-row>
                    <v-row style="justify-content:center">
                        <div class="box-border">
                            <v-btn @click="loadApi(logData)" color="green" dark>
                                {{$t('search')}}
                            </v-btn>
                        </div>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>





                <vue-good-table :columns="columns"
                                :rows="rows"
                                mode="remote"
                                :totalRows="branchData.totalRecords"
                                :pagination-options="{ enabled: true,mode: 'records' }"
                                @on-page-change="onPageChange"
                                @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                styleClass="vgt-table condensed">
                    <template slot="table-column" slot-scope="props">
                        <span>
                            {{ $t(props.column.label) }}
                        </span>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'establishedYear'">
                            <span>{{props.row.establishedYear | moment("DD-MMM-YYYY, h:mm:ss a")}}</span>
                        </span>
                        <span v-else-if="props.column.field == 'actions'">
                            <v-btn color="primary ml-4" @click="editModal(props.row)">{{$t('view')}}</v-btn>
                        </span>
                    </template>
                </vue-good-table>
    </v-content>
</template>

<script>
    import axios from "axios";
    import { mapGetters } from "vuex";
    import OfficeBudgetExpensesUserList from "./OfficeBudgetExpensesUserList";

    export default {
        name: 'AnucharuIndex',
        watch: {},
        components: {
            OfficeBudgetExpensesUserList
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true
                    },
                    {
                        text: this.$t('expenses_budget_report'),
                        disabled: true,
                    },
                ]
            },
        },


        data() {
            return {
                index: 0,
                officeTypeEN: "",
                editAnusucharuIndex: 0,
                columns: [
                    {
                        label: 'name',
                        field: 'name',
                    },
                    {
                        label: 'code',
                        field: 'code',
                    },
                    {
                        label: 'officetype',
                        field: 'officeType',
                    },

                    //{
                    //    label: 'Established Year',
                    //    field: 'establishedYear',
                    //},
                    { label: "actions", field: "actions" }
                ],
                rows: [],
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                logData: {
                    companyID: 0,
                    departmentID: 0,
                    branchID: 0,
                    depoID: 0,
                    reportID: 0,
                    year: "2081",
                    reportLogID: 0,
                    isActive: null
                },
                branchData: {
                    totalRows: 0,
                    editItemIndex: null,
                    editItemofficeType: null,
                    deleteFormData: {},
                    deleteFormOfficeData: {}
                },
                IsActive: false,
                headers: [],
                companyData: {},
                titleHeaders: [],
                listDatas: [],
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "branchID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    userListComponent: false,
                    dialogDelete: false,
                    dynamicComponent: {
                        current: 'HeaderForm'
                    }
                }
            };
        },
        mounted() {
            this.loadApi()
            this.loadData()
            this.getDdlData()
        },
        methods: {
            //loadApi(){
            //    axios.get('Depo/List').then(response => {
            //        this.listDatas = response.data
            //        this.breadCrumbData()
            //    }).catch(err=>{
            //        console.log(err)})
            //},
            async loadApi() {
                if (this.officeTypeEN == 'Company') {
                    this.snackbar.isLoading = true;
                    let param = {
                        CompanyID: parseInt(this.logData.companyID),
                        BranchID: 0,
                        DepoID: 0,
                        PageSize: this.serverParams.perPage == -1 ? this.branchData.totalRecords : this.serverParams.perPage,
                        PageNo: this.serverParams.page,
                        OrderType: this.serverParams.sort[0].type,
                        OrderBy: this.serverParams.sort[0].field,
                        isActive: true
                    };
                    axios.post('Depo/OfficeList', param).then(response => {
                        this.rows = response.data.list.data
                        this.branchData.totalRecords = response.data.list.totalCount
                        this.snackbar.loading = false;
                    })
                }
                else if (this.officeTypeEN == 'Branch') {
                    this.snackbar.isLoading = true;
                    let param = {
                        CompanyID: 0,
                        BranchID: parseInt(this.logData.branchID),
                        DepoID: 0,
                        PageSize: this.serverParams.perPage == -1 ? this.branchData.totalRecords : this.serverParams.perPage,
                        PageNo: this.serverParams.page,
                        OrderType: this.serverParams.sort[0].type,
                        OrderBy: this.serverParams.sort[0].field,
                        isActive: true
                    };
                    axios.post('Depo/OfficeList', param).then(response => {
                        this.rows = response.data.list.data
                        this.branchData.totalRecords = response.data.list.totalCount
                        this.snackbar.loading = false;
                    })
                }
                else if (this.officeTypeEN == 'Depo') {
                    this.snackbar.isLoading = true;
                    let param = {
                        CompanyID: 0,
                        BranchID: 0,
                        DepoID: parseInt(this.logData.depoID),
                        PageSize: this.serverParams.perPage == -1 ? this.branchData.totalRecords : this.serverParams.perPage,
                        PageNo: this.serverParams.page,
                        OrderType: this.serverParams.sort[0].type,
                        OrderBy: this.serverParams.sort[0].field,
                        isActive: true
                    };
                    axios.post('Depo/OfficeList', param).then(response => {
                        this.rows = response.data.list.data
                        this.branchData.totalRecords = response.data.list.totalCount
                        this.snackbar.loading = false;
                    })
                }
                else {
                    this.snackbar.isLoading = true;
                    let param = {
                        CompanyID: parseInt(this.logData.companyID),
                        BranchID: parseInt(this.logData.branchID),
                        DepoID: parseInt(this.logData.depoID),
                        PageSize: this.serverParams.perPage == -1 ? this.branchData.totalRecords : this.serverParams.perPage,
                        PageNo: this.serverParams.page,
                        OrderType: this.serverParams.sort[0].type,
                        OrderBy: this.serverParams.sort[0].field,
                        isActive: true
                    };
                    axios.post('Depo/OfficeList', param).then(response => {
                        this.rows = response.data.list.data
                        this.branchData.totalRecords = response.data.list.totalCount
                        this.snackbar.loading = false;
                    })
                }
                
            },
            getDdlData() {
                    axios.get("Branch/DDLAllBranchList").then(response => {
                        this.listDDLData.branchList = response.data
                    })
                axios.get("Depo/DDLAllDepoList").then(response => {
                        this.listDDLData.depoList = response.data
                    })

            },
            loadData() {
                axios.get('Company/DDLCompanyList').then(response => {
                    this.listDDLData.companyList = response.data
                })
            },
            dialogueClose() {
                this.snackbar.userListComponent = false
                this.snackbar.formModal = false
                this.loadApi()
            },
            nullTitle(title) {
                return title == null
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadApi();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.loadApi();
            },

            onSortChange(params) {

                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadApi();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadApi();
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                this.snackbar.userListComponent = false

            },
            editModal(row) {
                this.index++;
                this.snackbar.formModal = true
                this.snackbar.userListComponent = true
                this.snackbar.createFormComponent = false

                this.companyData = row
            },
            formResponse(responseObj) {
                console.log(responseObj)
                this.snackbar.color = responseObj.status ? 'green' : 'red'
                this.snackbar.text = responseObj.text ? responseObj.text : 'Server Error'
                this.snackbar.snackbar = true
                this.loadApi();
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>
